import type { ReactNode } from 'react';

export const symbol_search_hands_free: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M325-111.5q-73-31.5-127.5-86t-86-127.5Q80-398 80-480.5t31.5-155q31.5-72.5 86-127t127.5-86Q398-880 480.5-880t155 31.5q72.5 31.5 127 86t86 127Q880-563 880-480.5T848.5-325q-31.5 73-86 127.5t-127 86Q563-80 480.5-80T325-111.5ZM450-142v-154q-58-10-99.5-53T296-450H142q10 124 97 210.5T450-142Zm60 0q125-10 211.5-97T818-450H664q-14 58-54.5 101T510-296v154ZM142-510h152l94-99q8-9 20-14t24-5h96q12 0 24 5t20 14l94 99h152q-11-132-108.5-221T480-820q-132 0-229.5 89T142-510Z"
		/>
	</svg>
);
